import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PayoutItemsApiAdapter } from '../adapters';
import { PayoutItemsFilters } from '../models';

export const useExportPayoutItems = () => {
    const [isExporting, setIsExporting] = useState(false);
    const { toast } = useToast();
    const { t } = useTranslation('codPayoutItems');

    const exportPayoutItems = async (
        filters: Partial<PayoutItemsFilters>,
        columns?: string[]
    ) => {
        setIsExporting(true);
        try {
            const httpClient = createHttpClient(apiClientWH);
            const adapter = new PayoutItemsApiAdapter(httpClient);

            const response = await adapter.exportPayoutItems(filters, columns);

            if (response.url_file) {
                // Abrir el archivo Excel en una nueva pestaña
                window.open(response.url_file, '_blank');

                toast({
                    title: t('export.success.title', 'Exportación exitosa'),
                    description: t('export.success.description', 'El archivo Excel se está descargando'),
                    variant: 'default',
                });
            } else {
                throw new Error('No se recibió URL del archivo');
            }
        } catch (error: any) {
            toast({
                title: t('export.error.title', 'Error al exportar'),
                description: error.message || t('export.error.unexpected', 'Ocurrió un error inesperado'),
                variant: 'destructive',
            });
        } finally {
            setIsExporting(false);
        }
    };

    return {
        exportPayoutItems,
        isExporting,
    };
};

